import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"
import { Modal } from "bootstrap"
import { TempFormHelper } from "~/helpers/temp_form_helper"
import { CurrencyHelper } from "~/helpers/currency_helper"
// This controller accepts events from the other Stimulus controllers to update the companies selection.

export default class extends Controller {
  static get values() {
    return {
      companyListId: { type: String, default: "" },
      selectedCompanyIds: { type: Array, default: [] },
      allSelected: { type: Boolean, default: false },
      exportPath: { type: String, default: "/lead/companies/export" },
      exportLimit: Number,
      totalCount: Number,
      planName: String,
    }
  }

  static targets = ["modalDeleteText", "exportModal"]

  submit(event) {
    this.performAction(event.target.value, "post")
  }

  destroy(event) {
    this.performAction(event.target.value, "delete")
  }

  export(event) {
    const selectedCount = this._getTotalCount()

    // Show modal if export will be limited
    if (selectedCount > this.exportLimitValue && this.hasExportModalTarget) {
      new Modal(this.exportModalTarget).show()
      return
    }

    this.performAction(event.target.value, "post")
  }

  confirmExport() {
    TempFormHelper.create(this.exportPathValue, "post", (form) => {
      if (this.allSelectedValue) {
        TempFormHelper.addHiddenInput(form, "company_list_id", this.companyListIdValue)
      } else {
        this.selectedCompanyIdsValue.forEach((id) => {
          TempFormHelper.addHiddenInput(form, "company_ids[]", id)
        })
      }
    }).submit()
  }

  updateSelection(event) {
    if (event.detail) {
      this.allSelectedValue = event.detail.allSelected
      this.selectedCompanyIdsValue = event.detail.dataSets
        .map((dataSet) => dataSet.companyId || dataSet.recordId)
        .filter(Boolean)
      const numberOfCompanies =
        this.allSelectedValue === true ? this.totalCountValue : this.selectedCompanyIdsValue.length
      const companyName = numberOfCompanies === 1 ? event.detail.dataSets[0]?.companyName : false

      if (companyName) {
        this.modalDeleteTextTarget.innerHTML = i18n.t("js.back.company_actions.modal_delete_name_html", {
          company_name: companyName,
        })
      } else {
        this.modalDeleteTextTarget.innerHTML = i18n.t("js.back.company_actions.modal_delete_html", {
          count: numberOfCompanies,
          number: CurrencyHelper.numberWithDelimiter(numberOfCompanies),
        })
      }
    }
  }

  performAction(url, method) {
    if (url) {
      TempFormHelper.create(url, method, (form) => {
        if (this.allSelectedValue) {
          TempFormHelper.addHiddenInput(form, "company_list_id", this.companyListIdValue)
        } else {
          this.selectedCompanyIdsValue.forEach((id) => {
            TempFormHelper.addHiddenInput(form, "company_ids[]", id)
          })
        }
      }).submit()
    }
  }

  _getTotalCount() {
    if (this.allSelectedValue) {
      return this.totalCountValue
    }

    return this.selectedCompanyIdsValue.length
  }

  upgrade(event) {
    event.preventDefault()
    const url = event.currentTarget.href
    const modal = Modal.getInstance(this.exportModalTarget)

    this.exportModalTarget.addEventListener(
      "hidden.bs.modal",
      () => {
        Turbo.visit(url, { frame: "checkout-modal" })
      },
      { once: true },
    )

    modal.hide()
  }
}
